var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`list-${_vm.listIconStyle ? 'cancel' : 'shield'}`},[_c('ul',_vm._l((_vm.blocks),function(block,idx){return _c('li',{key:idx,staticClass:"inj-html el-tiptap-editor__content",domProps:{"innerHTML":_vm._s(block?.fields?.text?.value)}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }